import React from 'react'

export default function BottomActionBar({ enabled, onClick }) {
  return (
    <div className="traffic-fine-package-bottom-bar">
      <button type="button" className={`traffic-fine-package-bottom-btn ${enabled ? 'is-enabled' : 'is-disabled'}`} onClick={onClick}>
        {enabled ? 'Ngừng gia hạn tự động' : 'Gia hạn tự động'}
      </button>
    </div>
  )
}
